/* eslint-disable @typescript-eslint/no-unused-expressions,@typescript-eslint/no-unused-vars */

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerBaseDatabaseDestinationComponent', [
    '$rootScope',
    'DesignerBaseSourceAndDestinationComponent',
    'DesignerSchema',

    function ($rootScope, DesignerBaseSourceAndDestinationComponent, DesignerSchema) {
      function DesignerBaseDatabaseDestinationComponent() {
        DesignerBaseSourceAndDestinationComponent.apply(this);

        this.schema_name;
        this.table_name;

        this.create_table;
        this.add_columns;

        this.pre_action_sql;
        this.post_action_sql;

        this.operation_type;

        this.column_mappings = [];
      }

      DesignerBaseDatabaseDestinationComponent.prototype = new DesignerBaseSourceAndDestinationComponent();

      DesignerBaseDatabaseDestinationComponent.prototype.getData = function () {
        const data = DesignerBaseSourceAndDestinationComponent.prototype.getData.call(this);

        _.extend(data, {
          database_connection_id: String(this.connection.id || ''),
          schema_name: this.schema_name,
          table_name: this.table_name,
          create_table: angular.isDefined(this.create_table) ? this.create_table : this.defaults.create_table,
          add_columns: angular.isDefined(this.add_columns) ? this.add_columns : this.defaults.add_columns,
          pre_action_sql: this.pre_action_sql,
          post_action_sql: this.post_action_sql,
          column_mappings: this.column_mappings || [],
          operation_type: this.operation_type || this.defaults.operation_type,
        });

        return data;
      };

      DesignerBaseDatabaseDestinationComponent.prototype.setFormData = function (data) {
        this.setData(data);

        DesignerBaseSourceAndDestinationComponent.prototype.setFormData.call(this, data);
      };

      DesignerBaseDatabaseDestinationComponent.prototype.setData = function (data) {
        this.database_connection_id = String(data.connection ? data.connection.id : '');
        this.schema_name = data.schema_name;
        this.table_name = data.table_name;
        this.create_table = data.create_table;
        this.add_columns = data.add_columns;
        this.operation_type = data.operation_type;
        this.pre_action_sql = data.pre_action_sql;
        this.post_action_sql = data.post_action_sql;
        this.column_mappings = data.column_mappings;

        DesignerBaseSourceAndDestinationComponent.prototype.setData.call(this, data);
      };

      return DesignerBaseDatabaseDestinationComponent;
    },
  ]);
})(window.angular);
